<template>
  <div id="statisticsCompany">
    <div class="container">

      <TipBox info :title="$t('tips.stats.title')">
        <span v-html="$t('tips.stats.description')"></span>
      </TipBox>

      <div class="tabs">
        <span class="tab" @click="tab = 'today'" :class="{ active: tab === 'today' }">{{ $t('stats.today') }}</span>
        <span class="tab" @click="tab = 'week'" :class="{ active: tab === 'week' }">{{ $t("stats.week") }}</span>
        <span class="tab" @click="tab = 'month'" :class="{ active: tab === 'month' }">{{ $t("stats.month") }}</span>
        <span class="tab" @click="tab = 'all'" :class="{ active: tab === 'all' }">{{ $t("stats.all") }}</span>
      </div>

      <Statistics :period="tab"></Statistics>

    </div>
  </div>
</template>

<script>
  import Statistics from "@/components/StatisticsCompany.vue";

  export default {
    name: "statisticsCompany",

    components: {
      Statistics
    },

    data() {
      return {
        tab: 'today'
      }
    }
  }
</script>